const levels = ['debug', 'info', 'warn', 'error'];

const levelFromEnv = (import.meta.env.VITE_LOG_LEVEL || 'warn').toLowerCase();
const minIndex = Math.max(levels.indexOf(levelFromEnv), 0);

function shouldLog(level) {
  return levels.indexOf(level) >= minIndex;
}

export const logger = {
  debug: (...args) => {
    if (shouldLog('debug')) {
      // eslint-disable-next-line no-console
      console.debug(...args);
    }
  },
  info: (...args) => {
    if (shouldLog('info')) {
      // eslint-disable-next-line no-console
      console.info(...args);
    }
  },
  warn: (...args) => {
    if (shouldLog('warn')) {
      // eslint-disable-next-line no-console
      console.warn(...args);
    }
  },
  error: (...args) => {
    if (shouldLog('error')) {
      // eslint-disable-next-line no-console
      console.error(...args);
    }
  },
};
